import Modal from '../../components/Modal';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Request from '../../utils/request';

const CHANGE_EVENT = 'change';
class EditInterests {
	constructor() {
		this.totalInterests = [];
		this._container = SelectorEngine.findOne('.js-edit-coach-details-interests');

		if (this._container) {
			this.init();
		}
	}

	init() {
		this._form = SelectorEngine.findOne('#lta-coach-details__edit-interests-form', this._container);

		this._errorContainer = SelectorEngine.findOne('.lta-edit-instrests-error-container', this._container);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._saveCta = SelectorEngine.findOne('.save-interests-cta', this._form);
		this._saveCta.addEventListener('click', (event) => this.submitEnquiry(event));

		this._exitModal = new Modal(SelectorEngine.findOne('#coach-details-interests-exit'), {});

		this._cancelCta = SelectorEngine.findOne('.lta-coach-details__edit-interests-back');
		this._cancelCta.addEventListener('click', () => this._exitModal.show());

		const popupCancel = SelectorEngine.findOne('.lta-coach-details__edit-interests-continue');
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.lta-coach-details__edit-interests-exit');
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});

		const interests = SelectorEngine.find('input[type="checkbox"]', this._form);
		for (const checkbox of interests) {
			if (checkbox.checked) {
				this.totalInterests.push(checkbox.value);
			}
			EventHandler.on(checkbox, CHANGE_EVENT, (event) => {
				this.handleCheckboxClick(event);
			});
		}
	}

	async submitEnquiry(event) {
		event.preventDefault();
		if (this.totalInterests.length < 3) {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this._form, 'validation-error');
			this._errorContainer.scrollIntoView();
		} else if (this.totalInterests.length > 3) {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this._form, 'max-validation-error');
			this._errorContainer.scrollIntoView();
		} else {
			this._errorContainer.classList.add('u-hidden');
			this._errorText.innerHTML = '';
			const payload = {
				updateCoachDetailsRequest: {
					myInterests: {
						subjectMatter: this.totalInterests
					}
				}
			};
			try {
				const url = `/api/coachdetails/update`;
				startLoadingAnimation(true);
				const responseData = await Request.post(url, payload);

				const { success } = responseData;
				if (success) {
					const redirectUrl = Manipulator.getDataAttribute(this._form, 'redirect-url');
					window.location.href = redirectUrl;
				} else {
					this._errorContainer.classList.remove('u-hidden');
					this._errorText.innerHTML = Manipulator.getDataAttribute(this._form, 'api-failed-error');
				}
			} catch {
				this._errorContainer.classList.remove('u-hidden');
				this._errorText.innerHTML = Manipulator.getDataAttribute(this._form, 'api-failed-error');
				this._errorContainer.scrollIntoView();
			} finally {
				stopLoadingAnimation();
			}
		}
	}

	handleCheckboxClick(event) {
		if (event.target.checked) {
			this.totalInterests.push(event.target.value);
		} else {
			this.totalInterests = this.totalInterests.filter((value) => value !== event.target.value);
		}
		if (this.totalInterests.length > 3) {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this._form, 'max-validation-error');
			this._errorContainer.scrollIntoView();
		} else {
			this._errorContainer.classList.add('u-hidden');
			this._errorText.innerHTML = '';
		}
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalEditInterests = new EditInterests();

export default globalEditInterests;
